// extracted by mini-css-extract-plugin
export default {"titleField":"StoryEdit_titleField__k-FVP","textArea":"StoryEdit_textArea__pftKB"};